const TEMPLATE_SELECTOR = '.js-counter';
const ANIMATED_NUMBER_CLASS = 'js-animated-number';
const INITIAL_CLASS = 'initiated';

const getDecimalPlaces = (value) => {
    const parts = value.toString().split('.');

    return parts.length > 1 ? parts[1].length : 0;
};

const formatNumber = (num, decimalPlaces) => {
    const formatted = decimalPlaces > 0 ? num.toFixed(decimalPlaces) : Math.floor(num).toString();

    return Number(formatted).toLocaleString().replace('.', ',');
};

const animateNumber = (numberEl, duration) => {
    const end = parseFloat(numberEl.dataset.number);
    const decimalPlaces = getDecimalPlaces(numberEl.dataset.number);
    let startTimestamp = null;

    const step = (timestamp) => {
        startTimestamp ??= timestamp;

        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const current = progress * end;

        numberEl.textContent = formatNumber(current, decimalPlaces);

        if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
};

export const initCounterItem = (counter, duration = 1000) => {
    const numberEl = counter.querySelector(`.${ANIMATED_NUMBER_CLASS}`);
    if (!numberEl) return;

    const rawValue = numberEl.textContent.trim();
    if (isNaN(rawValue) || !isFinite(rawValue)) return;

    numberEl.dataset.number = rawValue;
    numberEl.textContent = '0';
    counter.classList.add(INITIAL_CLASS);

    let hasAnimated = false;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(({ isIntersecting }) => {
                if (!isIntersecting || hasAnimated) return;
                hasAnimated = true;
                setTimeout(() => animateNumber(numberEl, duration), 800);
            });
        },
        { root: null, rootMargin: '0px', threshold: 1.0 },
    );

    observer.observe(counter);

    return () => observer.disconnect();
};

export const Stats = () => {
    document.querySelectorAll(TEMPLATE_SELECTOR).forEach((el) => initCounterItem(el));
};
